
<template>
  <article id="listen-page" class="column">
    <div id="track-list">
      <track-list-item
        v-for="track in tracklist"
        :key="track.track_number"
        v-bind:track="track"
        v-bind:soundcloud="soundcloud">
      </track-list-item>
    </div>
    <soundcloud-player
      v-for="track in tracklist"
      :key="track.track_number"
      v-bind:track="track"
      v-bind:soundcloud="soundcloud">
    </soundcloud-player>
  </article>
</template>

<script>
import SoundcloudPlayer from '@/components/ListenPage/SoundcloudPlayer'
import TrackListItem from '@/components/ListenPage/TrackListItem'

export default {
  name: 'listen-page',
  props: ['soundcloud', 'tracklist'],
  components: { SoundcloudPlayer, TrackListItem },
  beforeCreate: function () {
    document.body.className = 'listen-page'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ListenPage/ListenPage.vue?417d0a7e